import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';


function HeaderButtons() {
  return (
    <Box>
      <HeaderNotifications />

    </Box>
  );
}

export default HeaderButtons;
